var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 24,
    viewBox: "0 0 83 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_14836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.623 10.5691H26.4543V24H21.7704L20.451 21.3658C18.3179 23.1219 15.6901 24 12.5674 24C10.3464 24 8.30136 23.5989 6.43215 22.7967C4.56298 21.9946 3.02366 20.7371 1.8142 19.0244C0.604733 17.29 0 15.252 0 12.9106V11.0894C0 7.55556 1.26444 4.82385 3.79332 2.89431C6.34419 0.964768 9.5768 0 13.491 0C16.6357 0 19.2854 0.628726 21.4405 1.88618C23.6175 3.12195 25.047 4.85637 25.7286 7.08943L18.043 8.55288C17.6912 7.64228 17.0865 6.91599 16.2288 6.37398C15.3932 5.8103 14.4256 5.52846 13.3261 5.52846C11.9627 5.52846 10.8082 5.95122 9.86264 6.79674C8.93904 7.6206 8.47728 8.87808 8.47728 10.5691V13.4634C8.47728 15.0894 8.93904 16.3361 9.86264 17.2033C10.8082 18.0705 12.0067 18.5041 13.4581 18.5041C15.6131 18.5041 17.1304 17.4418 18.01 15.317H13.623V10.5691Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9219 24V0H36.0852L46.3146 11.4857H46.3824V0H54.3762V24H46.484L36.0174 12.1371H35.9158V24H27.9219Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3154 24L73.4091 20.8681H64.2039L63.2409 24H55.8484L64.5438 0H73.8056L82.3024 24H74.3154ZM65.9034 15.217H71.738L68.934 5.65106H68.8206L65.9034 15.217Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_14836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.4,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosvg);
export default __webpack_public_path__ + "static/media/logo.svg.d7b1e7a9ccac1a6cfb003535c6431bb0.svg";
export { ForwardRef as ReactComponent };